import css from "./Divider.module.css";

const BASE_CLASS: string = "f-AtomDivider";

export const Divider = () => {
  return <hr className={css[BASE_CLASS]} />;
};
